<div class="relative z-10 flex h-screen w-screen overflow-hidden">

  <!-- Desktop side rail -->
  <aside class="hidden md:flex md:flex-col md:justify-between glass-strong m-3 rounded-3xl p-4 w-[88px] lg:w-[248px] transition-all">
    <div>
      <!-- Brand -->
      <div class="flex items-center gap-3 px-2 py-3">
        <div class="grid h-10 w-10 place-items-center rounded-2xl text-lg font-black text-white shadow-lg"
             style="background: linear-gradient(135deg, #10b981, #059669);">S</div>
        <div class="hidden lg:block leading-tight">
          <p class="text-sm font-extrabold tracking-tight text-slate-900">Savinda</p>
          <p class="text-[11px] font-semibold uppercase tracking-wide text-emerald-700">Boardroom Booking</p>
        </div>
      </div>

      <!-- Nav -->
      <nav class="mt-6 flex flex-col gap-1.5">
        @for (item of nav; track item.path) {
          <a [routerLink]="item.path" routerLinkActive="nav-active"
             class="nav-link group">
            <span class="material-symbols-outlined text-[22px]">{{ item.icon }}</span>
            <span class="hidden lg:block text-sm font-semibold">{{ item.label }}</span>
          </a>
        }
      </nav>
    </div>

    <!-- Bottom -->
    <div>
      <div class="hidden lg:block rounded-2xl border border-emerald-100 bg-emerald-50 p-4">
        <p class="text-xs font-semibold text-slate-900">Need a room now?</p>
        <p class="mt-1 text-[11px] text-slate-500">Jump straight to today's availability.</p>
        <a routerLink="/book" class="btn-brand mt-3 w-full text-xs py-2">Quick book</a>
      </div>
      <p class="mt-3 hidden text-center text-[10px] text-slate-400 lg:block">© {{ year }} Savinda · Boardroom</p>
    </div>
  </aside>

  <!-- Main column -->
  <div class="flex min-w-0 flex-1 flex-col">
    <!-- Mobile brand bar -->
    <header class="md:hidden flex items-center gap-2.5 px-4 pt-4">
      <div class="grid h-9 w-9 place-items-center rounded-xl text-base font-black text-white shadow"
           style="background: linear-gradient(135deg, #10b981, #059669);">S</div>
      <div class="leading-tight">
        <p class="text-sm font-extrabold tracking-tight text-slate-900">Savinda</p>
        <p class="text-[10px] font-semibold uppercase tracking-wide text-emerald-700">Boardroom Booking</p>
      </div>
    </header>

    <main class="flex-1 overflow-y-auto px-4 pb-28 pt-4 md:px-6 md:pb-6 md:pt-6">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Global toast / validation popups -->
  <div class="pointer-events-none fixed inset-x-0 top-4 z-[60] flex flex-col items-center gap-2 px-4">
    @for (t of toasts(); track t.id) {
      <div class="pointer-events-auto w-full max-w-sm">
        <app-notification-alert [type]="t.type" [message]="t.message" [isLeaving]="t.isLeaving"
                                (close)="dismissToast(t.id)"></app-notification-alert>
      </div>
    }
  </div>

  <!-- Mobile bottom nav -->
  <nav class="md:hidden fixed inset-x-0 bottom-0 z-30 px-4 pb-4">
    <div class="glass-strong mx-auto flex max-w-md items-center justify-around rounded-2xl p-1.5">
      @for (item of nav; track item.path) {
        <a [routerLink]="item.path" routerLinkActive="mobile-active"
           class="mobile-link">
          <span class="material-symbols-outlined text-[24px]">{{ item.icon }}</span>
          <span class="text-[10px] font-semibold">{{ item.label }}</span>
        </a>
      }
    </div>
  </nav>
</div>
